// import React from "react";

// import { Users, ArrowRight } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { MainLayout } from "../layout/MainLayout";

// const Feature = ({ title, description, onClick }) => {
//   return (
//     <div
//       onClick={onClick}
//       className="bg-white rounded-xl shadow-sm p-6 hover:shadow-lg transition-all duration-200 
//         hover:-translate-y-1 cursor-pointer border border-gray-200 relative group"
//     >
//       <h2 className="text-xl font-semibold text-gray-900 mb-3">{title}</h2>
//       <p className="text-gray-600 text-sm mb-8">{description}</p>
//       <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
//         <ArrowRight className="w-5 h-5 text-blue-600" />
//       </div>
//     </div>
//   );
// };

// const Features = () => {
//   const userId = localStorage.getItem("userID");
//   const navigate = useNavigate();

//   const features = [
//     {
//       title: "CREATE YOUR OWN USER",
//       description:
//         "You can create your own user with dedicated username and password.",
//       path: "user-registeration",
//     },
//     {
//       title: "ASSIGN PROJECT TO USERS",
//       description: "Here you can assign specific project to users.",
//       path: "assign-projects",
//     },
//     {
//       title: "DELETE USER",
//       description: "Here, you can delete your specific user",
//       path: "delete-user",
//     },
//     {
//       title: "USERS'S PROJECTS",
//       description:
//         "Here, you can edit an existing project for platform or digital twin viewer",
//       path: "project-user-relation",
//     },
//     {
//       title: "RESET PASSWORD",
//       description: "Here, you can reset password for your desired users",
//       path: `password-reset/${userId}`,
//     },
//   ];

//   const handleFeatureClick = (path) => {
//     navigate(path);
//   };

//   return (
//     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//       {features.map((feature, index) => (
//         <Feature
//           key={index}
//           title={feature.title}
//           description={feature.description}
//           onClick={() => handleFeatureClick(`/${feature.path}`)}
//         />
//       ))}
//     </div>
//   );
// };

// // Main Component
// const UserManagement = () => {
//   const token = localStorage.getItem("token");

//   if (!token) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50">
//         <div className="text-center">
//           <p className="text-xl text-gray-600 mb-4">
//             Please login to view this page.
//           </p>
//           <a
//             href="/login"
//             className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg 
//               hover:bg-blue-700 transition-colors"
//           >
//             Go to Login
//           </a>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <MainLayout>
//       <div className="min-h-screen bg-gray-50 py-8">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="bg-white rounded-xl shadow-sm overflow-hidden">
//             {/* Header */}
//             <div className="px-6 py-8 border-b border-gray-200">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <h1 className="text-2xl font-bold text-gray-900">
//                     User Management
//                   </h1>
//                   <p className="mt-1 text-gray-600">
//                     Manage users, permissions, and access controls
//                   </p>
//                 </div>
//                 <div className="p-3 bg-blue-50 rounded-lg">
//                   <Users className="w-6 h-6 text-blue-600" />
//                 </div>
//               </div>
//             </div>

//             {/* Content */}
//             <div className="p-6">
//               <Features />

//               {/* Helper Information */}
//               <div className="mt-8 p-4 bg-gray-50 rounded-lg border border-gray-200">
//                 <h3 className="text-sm font-medium text-gray-900 mb-2">
//                   Quick Tips
//                 </h3>
//                 <ul className="space-y-2">
//                   <li className="text-sm text-gray-600 flex items-start">
//                     <span className="mr-2">•</span>
//                     Create and manage user accounts with specific permissions
//                   </li>
//                   <li className="text-sm text-gray-600 flex items-start">
//                     <span className="mr-2">•</span>
//                     Assign users to projects and control their access levels
//                   </li>
//                   <li className="text-sm text-gray-600 flex items-start">
//                     <span className="mr-2">•</span>
//                     Manage user credentials and reset passwords when needed
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </MainLayout>
//   );
// };

// export default UserManagement;
import React from "react";
import { Users, ArrowRight, UserPlus, Settings, Trash2, Shield, Key, Lightbulb } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { MainLayout } from "../layout/MainLayout";

const Feature = ({ title, description, onClick, icon: Icon, gradientColors }) => {
  return (
    <div
      onClick={onClick}
      className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden hover:shadow-2xl 
        transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
    >
      {/* Feature Header */}
      <div className={`${gradientColors} p-4 relative overflow-hidden`}>
        <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
        <div className="relative z-10 flex items-center justify-between">
          <div className="inline-flex items-center justify-center w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl">
            <Icon className="w-5 h-5 text-white" />
          </div>
          <ArrowRight className="w-5 h-5 text-white/80 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-200" />
        </div>
        
        {/* Decorative Elements */}
        <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
        <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
      </div>

      {/* Feature Content */}
      <div className="p-6">
        <h3 className="text-lg font-bold text-slate-800 mb-3 group-hover:text-blue-600 transition-colors duration-200">
          {title}
        </h3>
        <p className="text-slate-600 text-sm leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
};

const Features = () => {
  const userId = localStorage.getItem("userID");
  const navigate = useNavigate();

  const features = [
    {
      title: "CREATE YOUR OWN USER",
      description: "You can create your own user with dedicated username and password.",
      path: "user-registeration",
      icon: UserPlus,
      gradientColors: "bg-gradient-to-br from-blue-600 to-indigo-600"
    },
    {
      title: "ASSIGN PROJECT TO USERS",
      description: "Here you can assign specific project to users.",
      path: "assign-projects",
      icon: Settings,
      gradientColors: "bg-gradient-to-br from-green-600 to-emerald-600"
    },
    {
      title: "DELETE USER",
      description: "Here, you can delete your specific user",
      path: "delete-user",
      icon: Trash2,
      gradientColors: "bg-gradient-to-br from-red-600 to-rose-600"
    },
    {
      title: "USERS'S PROJECTS",
      description: "Here, you can edit an existing project for platform or digital twin viewer",
      path: "project-user-relation",
      icon: Shield,
      gradientColors: "bg-gradient-to-br from-purple-600 to-pink-600"
    },
    {
      title: "RESET PASSWORD",
      description: "Here, you can reset password for your desired users",
      path: `password-reset/${userId}`,
      icon: Key,
      gradientColors: "bg-gradient-to-br from-orange-600 to-amber-600"
    },
  ];

  const handleFeatureClick = (path) => {
    navigate(path);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {features.map((feature, index) => (
        <Feature
          key={index}
          title={feature.title}
          description={feature.description}
          onClick={() => handleFeatureClick(`/${feature.path}`)}
          icon={feature.icon}
          gradientColors={feature.gradientColors}
        />
      ))}
    </div>
  );
};

// Main Component
const UserManagement = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-xl border border-slate-200 p-8 text-center max-w-md">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-red-600 to-rose-600 rounded-xl mb-6">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">Authentication Required</h2>
          <p className="text-lg text-slate-600 mb-6">
            Please login to access the User Management portal.
          </p>
          <a
            href="/login"
            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 
              hover:from-blue-700 hover:to-indigo-700 text-white rounded-xl font-semibold 
              transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            Go to Login
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    );
  }

  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Page Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl mb-6 shadow-lg">
              <Users className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-4">
              User Management
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Manage users, permissions, and access controls for your Digital Twin platform
            </p>
          </div>

          {/* Main Content Card */}
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-br from-blue-600 to-indigo-600 p-8 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
              <div className="relative z-10">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-2">
                      User Administration
                    </h2>
                    <p className="text-white/90">
                      Complete control over user accounts and project assignments
                    </p>
                  </div>
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl">
                    <Users className="w-6 h-6 text-white" />
                  </div>
                </div>
              </div>
              
              {/* Decorative Elements */}
              <div className="absolute -top-8 -right-8 w-24 h-24 bg-white/10 rounded-full"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-white/10 rounded-full"></div>
            </div>

            {/* Content */}
            <div className="p-8">
              <Features />

              {/* Helper Information */}
              <div className="mt-8 bg-slate-50 rounded-xl border border-slate-200 overflow-hidden">
                <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-4">
                  <div className="flex items-center gap-3">
                    <div className="inline-flex items-center justify-center w-8 h-8 bg-white/20 backdrop-blur-sm rounded-lg">
                      <Lightbulb className="w-4 h-4 text-white" />
                    </div>
                    <h3 className="text-lg font-bold text-white">Quick Tips</h3>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                      <div>
                        <h4 className="font-semibold text-slate-800 text-sm mb-1">User Creation</h4>
                        <p className="text-slate-600 text-sm">Create and manage user accounts with specific permissions</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-green-600 rounded-full mt-2 flex-shrink-0"></div>
                      <div>
                        <h4 className="font-semibold text-slate-800 text-sm mb-1">Project Assignment</h4>
                        <p className="text-slate-600 text-sm">Assign users to projects and control their access levels</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-purple-600 rounded-full mt-2 flex-shrink-0"></div>
                      <div>
                        <h4 className="font-semibold text-slate-800 text-sm mb-1">Security Management</h4>
                        <p className="text-slate-600 text-sm">Manage user credentials and reset passwords when needed</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default UserManagement;